import { render, staticRenderFns } from "./VacationCommentField.vue?vue&type=template&id=824e2cc0&"
import script from "./VacationCommentField.vue?vue&type=script&lang=js&"
export * from "./VacationCommentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports